import Vuex from 'vuex'
import Vue from 'vue'
import {
  getUserInfo
} from '../api/api.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {},
    token: ''
  },

  getters: {
    userInfo(state) {
      return state.userInfo
    },
    token(state) {
      return state.token
    }
  },

  mutations: {
    SET_USERINFO(state, data) {
      state.userInfo = data
      localStorage.setItem('uInfo', JSON.stringify(data))
      localStorage.setItem('uId', data.id)
    },
    SET_TOKEN(state, data) {
      state.userInfo = data
    },
    LOG_OUT(state, data) {
      state.userInfo = {}
      localStorage.removeItem('uInfo')
      localStorage.removeItem('uId')
    }
  },
  actions: {
    getUserInfo2({
      commit
    }, uid) {
      return new Promise((resolve, reject) => {
        getUserInfo({
          id: uid
        }).then(res => {
          console.log(res);
          commit('SET_USERINFO', res.data.data)
        })
      });
    },
    logOut({
      commit
    }) {
      return new Promise((resolve, reject) => {
        commit('LOG_OUT', 0)
      });
    }
  },

  modules: {}

})

// 暴露实例

export default store



// WEBPACK FOOTER //
// ./src/store/index.js